import { lazy, Suspense, type ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { DocumentIcon } from "@/components/icons";
import { RequirePermission } from "@/components/RequirePermission";
import { ROUTES } from "@/config/routes";
import type { FeatureModule } from "@/types/feature";

const CompletedTasksPage = lazy(() =>
  import("./CompletedTasksPage").then((m) => ({ default: m.CompletedTasksPage }))
);

function Loader() {
  return <div style={{ padding: 20, color: "var(--text-muted)", fontSize: 14 }}>Loading…</div>;
}

/** Gate the route on feature.completed-tasks.access (client mirror of the server). */
function guard(element: ReactNode): ReactNode {
  return (
    <RequirePermission perm="feature.completed-tasks.access" redirectTo={ROUTES.overview}>
      <Suspense fallback={<Loader />}>{element}</Suspense>
    </RequirePermission>
  );
}

/**
 * Asana Tasks registration. The feature id and permission keep the first
 * name, Completed Tasks. Gated on feature.completed-tasks.access —
 * seeded to no role but superadmin and granted per person, the same pilot
 * model the other Asana-backed surface uses.
 */
export const completedTasksFeature: FeatureModule = {
  id: "completed-tasks",
  navItems: [
    {
      id: "completed-tasks",
      label: "Asana Tasks",
      path: ROUTES.asanaTasks,
      icon: DocumentIcon,
      requires: "feature.completed-tasks.access",
    },
  ],
  routes: [
    { path: ROUTES.asanaTasks, element: guard(<CompletedTasksPage />) },
    // Redirect the old URL so a bookmarked /completed-tasks keeps working.
    { path: "/completed-tasks", element: <Navigate to={ROUTES.asanaTasks} replace /> },
  ],
};
